<!-- 手机注册 -->
<template>
  <div class="RegisterForm-Component">
    <!-- 注册步骤1: 检查手机验证码 start -->
    <form v-show="step === 1" class="RegisterForm login-sign-form">
      <!-- 国家/地区 -->
      <div class="form-put-title">{{ $t('lang108') }}</div>
      <country-select @on-change="countrySelectChange" />

      <!-- 电话号码 -->
      <div class="form-put-title">{{ $t('lang109') }}</div>
      <div class="phone-number-tab">
        <div class="phone-number-box phone-code-box">
          <p class="phone-number-prev">+{{ yourPhonePrevCode }}</p>
          <input v-model="yourPhoneNumber" />
        </div>

        <!-- 发送验证码 -->
        <div
          :class="['btn-send', { 'btn-can-send': canSendCode }]"
          @click="getVerficationCode"
          v-text="countTxt"
        ></div>
      </div>

      <div class="form-put-title">{{ $t('lang112') }}</div>
      <!-- 滑块验证 -->
      <div class="form-put-vcode">
        <div id="captcha-box-register" class="captcha-box"></div>
      </div>

      <!-- 验证码 -->
      <div class="form-put-title">{{ $t('lang113') }}</div>
      <div class="password-tab">
        <input v-model="verficationCode" type="text" />
      </div>

      <!-- 协议 -->
      <policy
        :showAgreeTips="showAgreeTips"
        @hideAgreeTips="showAgreeTips = false"
        @emitAgree="emitAgree"
      />

      <!-- 下一步 -->
      <button
        :class="['btn-sumbit', { 'btn-loading': loading, 'btn-gray': btnGray }]"
        type="button"
        @click="checkCode"
      >
        <span v-if="loading" class="icon-loading">
          <img :src="require('@assets/img/loading.gif')" />
        </span>
        {{ $t('lang114') }}(1/2)
      </button>
    </form>
    <!-- 注册步骤1: 检查手机验证码 end -->

    <!-- 注册步骤2: 设置密码 start -->
    <form v-show="step === 2" class="RegisterForm login-sign-form">
      <div :class="['seeable-bg-e', { nosee: !passwordVisible }]"></div>
      <div class="form-put-title">{{ $t('lang170') }}</div>
      <div class="password-tab seeable_password">
        <input
          v-model="password"
          :type="passwordVisible ? 'text' : 'password'"
          maxlength="22"
        />
        <a
          href="javascript:;"
          :class="['seeable_password_btn', { nosee: !passwordVisible }]"
          @click="passwordVisible = !passwordVisible"
        ></a>
      </div>
      <div class="form-put-title create_password_rules">
        {{ $t('lang116') }}
      </div>

      <!-- 协议 -->
      <policy
        :showAgreeTips="showAgreeTips"
        @hideAgreeTips="showAgreeTips = false"
        @emitAgree="emitAgree"
      />

      <!-- 注册 -->
      <div
        :class="['btn-sumbit', { 'btn-loading': loading, 'btn-gray': btnGray }]"
        type="button"
        @click="register"
      >
        <span v-if="loading" class="icon-loading">
          <img :src="require('@assets/img/loading.gif')" />
        </span>
        {{ $t('lang105') }}(2/2)
      </div>
    </form>
    <!-- 注册步骤2: 设置密码 end -->
  </div>
</template>

<script>
import { statusCodeMapping } from '@constant';
import { getParamFromUrl } from '@assets/js/utils';
import CountrySelect from './CountrySelect';
import codeCounter from './codeCounter';
import Policy from './Policy';
/* eslint-disable */
export default {
  components: {
    CountrySelect,
    Policy
  },
  mixins: [codeCounter],
  props: {
    // activeTab: {
    //   type: Number,
    //   default: 1
    // },
    registerPhone: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      yourCountryName: '',
      yourCountryCode: '',
      yourPhonePrevCode: '',
      yourPhoneNumber: '',
      password: '',
      captchaToken: '',
      verficationCode: '',
      btnCodeCanClick: true,
      // 验证码发送按钮文案
      countTxt: 'Send',
      loading: false,
      passwordVisible: true,
      // 是否同意隐私政策
      isAgree: true,
      showAgreeTips: false,
      step: 1
    };
  },
  computed: {
    canSendCode() {
      if (!this.btnCodeCanClick) {
        return false;
      }

      const { yourPhoneNumber, captchaToken, yourPhonePrevCode } = this;
      if (
        yourPhoneNumber.length === 0 ||
        yourPhonePrevCode.length === 0 ||
        captchaToken.length === 0
      ) {
        return false;
      }

      return true;
    },
    btnGray() {
      if (this.step === 1) {
        if (!this.yourPhoneNumber || !this.verficationCode) {
          return true;
        }
      } else if (this.step === 2) {
        if (!this.password) {
          return true;
        }
      }

      return false;
    }
  },
  mounted() {
    this.yourPhoneNumber = this.registerPhone;
    setTimeout(() => {
      this.initCaptcha();
    }, 0);
  },
  methods: {
    emitAgree(agree) {
      this.isAgree = agree;
    },
    countrySelectChange(val) {
      const { countryName, countryCode, phonePrevCode } = val;
      this.yourCountryName = countryName;
      this.yourCountryCode = countryCode;
      this.yourPhonePrevCode = phonePrevCode;
    },
    // 登录校验滑块加载
    initCaptcha() {
      const captchaSize = {
        width: '300px',
        height: '40px',
        fontsize: '14px',
        business: 'bigolive-web',
        scene: 'register'
      };
      this.captchaLogin = new window.BigoCaptcha.Captcha();
      this.captchaLogin.initWithParams(
        {
          id: 'captcha-box-register',
          ...captchaSize
        },
        (res) => {
          if (res && res.status === 2) {
            this.captchaToken = res.token;
          }
        }
      );
    },
    // 获取验证码
    async getVerficationCode() {
      if (!this.btnCodeCanClick) return;
      const { yourPhoneNumber, captchaToken, yourPhonePrevCode } = this;
      let errorTips = '';
      if (yourPhoneNumber.length === 0) {
        errorTips = statusCodeMapping[101];
      }
      if (yourPhonePrevCode.length === 0) {
        errorTips = statusCodeMapping[100];
      }
      if (captchaToken.length === 0) {
        errorTips = statusCodeMapping.register_vcode;
      }
      if (errorTips) return this.$toast(this.$t(errorTips));

      const data = {
        interfaceName: 'sendCode',
        phone: yourPhoneNumber,
        phone_code: yourPhonePrevCode,
        is_reset: 0,
        vcode: captchaToken
      };
      const res = await this.$api.sendCode(data);
      if (res && +res.code === 0) {
        // 出弹窗
        this.$toast(this.$t(statusCodeMapping[110]));
        this.sendCodeCounter();
        this.$log && this.$log.info('sendCode success', { msg: res.code });
      } else {
        this.$toast(
          statusCodeMapping[res.code]
            ? this.$t(statusCodeMapping[res.code])
            : `${res?.code}: ${res?.msg}`
        );
        this.$log && this.$log.error('sendCode error', { msg: res.code });
      }
      this.initCaptcha();
    },
    // step1: 检查验证码
    async checkCode() {
      if (!this.isAgree) {
        this.showAgreeTips = true;
        return;
      }

      const { yourPhoneNumber, yourPhonePrevCode, verficationCode } = this;
      let errorTips = '';
      if (yourPhoneNumber.length === 0) {
        errorTips = statusCodeMapping[101];
      }
      if (yourPhonePrevCode.length === 0) {
        errorTips = statusCodeMapping[100];
      }
      if (verficationCode.length === 0) {
        errorTips = statusCodeMapping[102];
      }
      if (errorTips) return this.$toast(this.$t(errorTips));

      const data = {
        interfaceName: 'checkCode',
        phone: yourPhoneNumber,
        phone_code: yourPhonePrevCode,
        is_reset: 0,
        code: verficationCode
      };
      this.loading = true;
      const res = await this.$api.checkCode(data);
      if (res && +res.code === 0) {
        // this.$emit('next-step', 2);
        this.step = 2;
      } else {
        this.$toast(
          statusCodeMapping[res.code]
            ? this.$t(statusCodeMapping[res.code])
            : `${res?.code}: ${res?.msg}`
        );
      }
      this.loading = false;
    },
    // step2: 注册
    async register() {
      if (!this.isAgree) {
        this.showAgreeTips = true;
        return;
      }

      const {
        yourPhoneNumber,
        verficationCode,
        yourPhonePrevCode,
        password
      } = this;
      let errorTips = '';
      if (password.length < 6 || password.length > 16) {
        errorTips = statusCodeMapping[104];
      } else if (!/^\w{6,16}$/.test(password)) {
        errorTips = statusCodeMapping[105];
      }
      if (errorTips) return this.$toast(this.$t(errorTips));

      const data = {
        interfaceName: 'register',
        phone: yourPhoneNumber,
        code: verficationCode,
        pwd: password,
        phone_code: yourPhonePrevCode
      };

      this.loading = true;
      const res = await this.$api.register(data);
      if (res && +res.code === 0) {
        this.$toast('Success');
        const channel = getParamFromUrl('c');
        this.$log &&
          this.$log.info('register success', {
            msg: `${res.code} channel = ${channel}`
          });
        window.location.reload();
      } else {
        this.$toast(`${res.code}: ${res.msg}`);
        this.$log && this.$log.error('register error', { msg: res.code });
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
#captcha-box-register-bigo-captcha-element {
  background-color: #f5f7fa !important;
}
</style>

<style lang="scss" scoped>
@import './form.scss';

.seeable-bg-e {
  width: 100%;
  height: 120px;
  margin-top: 20px;
  margin-bottom: 10px;
  background: url(~@assets/img/password1.png);
  background-size: cover;

  &.nosee {
    background-image: url(~@assets/img/password2.png);
  }
}

.seeable_password {
  position: relative;

  .seeable_password_btn {
    position: absolute;
    top: 12px;
    right: 16px;
    display: block;
    width: 18px;
    height: 18px;
    z-index: 9;
    overflow: hidden;
    background: url(~@assets/img/icon2.png) -1px -490px no-repeat;

    &:hover {
      background: url(~@assets/img/icon2.png) -20px -490px no-repeat;
    }

    &.nosee {
      background: url(~@assets/img/icon2.png) -1px -470px no-repeat;

      &:hover {
        background: url(~@assets/img/icon2.png) -20px -470px no-repeat;
      }
    }
  }
}
</style>
